import React from 'react'
import Paper from "@material-ui/core/Paper";
import ErrorBackground from '../../assets/error-de-localizacion-background.jpg'
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {createStyles} from "@material-ui/core";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles(theme => createStyles({
    responseContainer: {
        backgroundColor: 'transparent',
        padding: 32,
        display: 'flex',
        marginLeft: 'auto',
        marginRight: 'auto',
        flexFlow: 'column nowrap',
        alignItems: 'center',
        width: 320,
        maxWidth: '600px',
        zIndex: 9,
    },
    iconFailure: {
        color: 'red',
        fontSize: 120,
        width: 'auto',
        height: '30vh',
        maxHeight: 100,
        zIndex: 9,
    },
    titleTheme: {
        color: 'black',
        fontWeight: 'normal',
        width: '80%',
        maxWidth: 230,
        marginTop: 120,
        textAlign: 'center',
        zIndex: 9,
    },
    backgroundFailure: {
        position: 'absolute',
        [theme.breakpoints.down(480)]: {
            right: 0
        },
        top: 0,
        zIndex: 1,
        height: '100vh'
    },
    button: {
        color: "white",
        backgroundColor: "#28C339",
        borderColor: "#28C339",
        marginTop: 10,
        zIndex: 9,
        width: '100%',
        maxWidth: '300px',
        "&:hover":{
            backgroundColor: "white",
            color: '#28C339',
            borderColor: "#28C339",
        }
    },
}));

const NoInfoAvailable = () => {
    const {
        responseContainer,
        titleTheme,
        backgroundFailure,
        button
    } = useStyles();

    let country = sessionStorage.getItem('country');
    const urlContactFormByCountry = () => {
        switch(country) {
            case 'Ecuador':
                return 'ec';
            case 'Mexico':
                return 'mex';
            case 'Argentina':
                return 'arg';
            case 'Chile':
                return 'chl';
            default:
                return 'arg';
        }
    }

    const urlHome = `http://support.pago46.io/contact-us/problemas-app-${urlContactFormByCountry()}`

    return(
        <div>
            <Paper data-testid='error-screen' elevation={0} className={responseContainer} style={{ width: '80%' }}>
                <img alt="" src={ErrorBackground} className={backgroundFailure}/>
                <Typography variant={'h6'} className={titleTheme}>Parece que hay un error!</Typography>
                <a href={urlHome}>
                    <Button
                        color="primary"
                        className={button}
                        variant="outlined"
                    > Contáctanos en caso de algún problema haciendo click aquí
                    </Button>
                </a>
            </Paper>
        </div>
    )
}

export default NoInfoAvailable